var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { Router } from "aurelia-router";
import { autoinject, transient } from "aurelia-framework";
import { BaseOdataTicketLines } from "../../ticket-lines/base-odata-ticket-lines";
var GamePlayerTicketLines = /** @class */ (function (_super) {
    __extends(GamePlayerTicketLines, _super);
    function GamePlayerTicketLines(notificationService, i18N, queriesService, router) {
        var _this = _super.call(this, notificationService, i18N, queriesService, router) || this;
        _this.queriesService = queriesService;
        _this.router = router;
        return _this;
    }
    GamePlayerTicketLines.prototype.GetFilteringQuery = function () {
        return "/odata/".concat(this.getPath(), "?$filter=gamePlayerId eq ").concat(this.item.gamePlayerId);
    };
    GamePlayerTicketLines = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            QueriesClientService, Router])
    ], GamePlayerTicketLines);
    return GamePlayerTicketLines;
}(BaseOdataTicketLines));
export { GamePlayerTicketLines };
